import $ from 'jquery'

if ($('.embroidery').length > 0) {
  $('.embroidery__checkbox').on('change', function () {
    if ($(this).prop('checked')) {
      $('.shopify-payment-button').hide()

      $('.embroidery-options').addClass('embroidery-options--active')

      // Add names so added as attribute
      $('.embroidery-fonts__font input').attr('name', 'properties[Embroidery font]')
      $('.embroidery-colors__color input').attr('name', 'properties[Embroidery color]')
      $('#embroidery-text').attr('name', 'properties[Embroidery text]')

      // Move to the embroidery images
      var slickObjectMain = $('.main-product-images-images').slick('getSlick')
      var totalSlidesMain = slickObjectMain.slideCount
      var fourthToLastIndexMain = totalSlidesMain - 6 // Calculate the fourth-to-last index

      var slickObjectThumbs = $('.main-product-images-thumbs').slick('getSlick')
      var totalSlidesThumbs = slickObjectThumbs.slideCount
      var fourthToLastIndexThumbs = totalSlidesThumbs - 6 // Calculate the fourth-to-last index

      // Go to the fourth-to-last slide
      $('.main-product-images-images').slick('slickGoTo', fourthToLastIndexMain)
      $('.main-product-images-thumbs').slick('slickGoTo', fourthToLastIndexThumbs)
    } else {
      $('.shopify-payment-button').show()
      $('.embroidery-options').removeClass('embroidery-options--active')

      // Remove names so not added as attribute
      $('.embroidery-fonts__font input').attr('name', '')
      $('.embroidery-colors__color input').attr('name', '')
      $('#embroidery-text').attr('name', '')
    }
  })

  // Thread color
  $(document).on('change', '[name="properties[Embroidery color]"]', function () {
    const color = $(this).val().toLowerCase()
    $('#embroidery-text-preview').removeClass('black').removeClass('silver').removeClass('gold').addClass(color)
  })

  // Font
  $(document).on('change', '[name="properties[Embroidery font]"]', function () {
    const font = $(this).val().toLowerCase().replace(' ', '-')

    $('#embroidery-text-preview')
      .removeClass('font-helvetica')
      .removeClass('font-athletic-flair')
      .removeClass('font-flair')
      .addClass(`font-${font}`)
  })

  // Live text
  $('#embroidery-text').on('keyup', function () {
    const value = $(this).val()

    $('#embroidery-text-preview').text(value)

    const charCount = value.length
    const el = document.getElementById('embroidery-text-preview')
    let fontSize = 70
    if (charCount > 4) fontSize -= charCount * 2

    el.style.fontSize = fontSize + 'px'
  })
}
